import { Link } from "react-router-dom";
import ArticleCard, { type ArticleItem } from "@/components/base/ArticleCard";
import HotRanking from "@/pages/home/components/HotRanking";

interface Props {
  feature: ArticleItem;
  secondary: ArticleItem[];
}

export default function FeaturedSection({ feature, secondary }: Props) {
  return (
    <section className="px-4 md:px-8 py-14 md:py-20 bg-background-100">
      <div className="flex items-center gap-3">
        <span className="w-1.5 h-7 rounded-full bg-primary-500" />
        <h2 className="font-heading font-black text-2xl md:text-3xl text-foreground-950">今日精选</h2>
        <span className="ml-auto text-xs text-foreground-500 hidden sm:flex items-center gap-1">
          <i className="ri-time-line" />
          编辑于 09:00 更新
        </span>
      </div>

      <div className="mt-8 grid lg:grid-cols-12 gap-8">
        <div className="lg:col-span-8 flex flex-col gap-6">
          <ArticleCard article={feature} variant="feature" />
          <div className="grid sm:grid-cols-2 gap-5">
            {secondary.map((a) => (
              <ArticleCard key={a.id} article={a} />
            ))}
          </div>
        </div>
        <aside className="lg:col-span-4">
          <div className="lg:sticky lg:top-28">
            <HotRanking />
            <Link
              to="/daily"
              className="mt-5 flex items-center justify-between px-5 py-4 rounded-lg border border-background-200 bg-background-50 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <span>
                <span className="block font-heading font-bold text-foreground-950">往期日报归档</span>
                <span className="block text-xs text-foreground-500 mt-1">按栏目与日期快速回溯</span>
              </span>
              <i className="ri-arrow-right-up-line text-xl text-primary-600" />
            </Link>
          </div>
        </aside>
      </div>
    </section>
  );
}